// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IContactPreferenceModel {
    static getAttributeTypeMap() {
        return IContactPreferenceModel.attributeTypeMap;
    }
}
IContactPreferenceModel.discriminator = undefined;
IContactPreferenceModel.additionalProperties = false;
IContactPreferenceModel.attributeTypeMap = [
    {
        "name": "contactInfoType",
        "baseName": "contactInfoType",
        "type": "ContactInformationType"
    },
    {
        "name": "setAllOthersToNotPreferred",
        "baseName": "setAllOthersToNotPreferred",
        "type": "boolean"
    },
    {
        "name": "isOptedIn",
        "baseName": "isOptedIn",
        "type": "boolean"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    },
];
//# sourceMappingURL=iContactPreferenceModel.js.map